<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Qa6SDo/tc-custom/9781524852726.jpg?1708400931369" alt="This image is the cover for the book Sparks of Phoenix"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sparks of Phoenix
      </h1>
      <p class="bookDescription body article font2">
        <p>As the phoenix emerges from its ashes, Zebian emerges ablaze in these pages, not only as a survivor of abuse, but as a teacher and healer for all those who have struggled to understand, reclaim, and rise above a history of pain.<br/><br/>The book is divided into six chapters, and six stages of healing: Falling, Burning to Ashes, Sparks of Phoenix, Rising, Soaring, and finally, A New Chapter, which demonstrates a healthy response to new love as the result of authentic healing.<br/><br/>With her characteristic vulnerability, courage, and softness, Zebian seeks to empower those who have been made to feel ashamed, silenced, or afraid; she urges them, through gentle advice and personal revelation, to raise their voices, rise up, and soar.<br/> </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Najwa Zebian
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8a8e9568